import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { AiFillCaretDown, AiFillCaretUp } from 'react-icons/ai'
import { Link } from 'wouter'
import SubMenuItems from './SubMenuItems'

// Match robusto para rutas - CORREGIDO para manejar la ruta raíz
const isRouteActive = (currentPath, targetPath) => {
  const cur = String(currentPath || '').trim()
  const tgt = String(targetPath || '').trim()

  if (!tgt) return false
  
  // Caso especial: ruta raíz debe ser exacta
  if (tgt === '/') {
    return cur === '/'
  }
  
  // Para otras rutas: exact match o prefijo
  if (cur === tgt) return true
  if (cur.startsWith(tgt.endsWith('/') ? tgt : `${tgt}/`)) return true

  return false
}

export default function MenuItems({ item, location, isSidebarOpen }) {
  const nowrap = !isSidebarOpen ? 'whitespace-nowrap' : ''

  const baseClasses =
    'inline-flex pr-3 pl-4 py-1.5 text-base text-white duration-300 grow border-s-0 hover:border-s-2 hover:border-[#FCAE52] hover:text-[#FCAE52]'

  // Activo si cualquier hijo "matchea" por prefijo
  const isChildActive = useMemo(() => {
    return Boolean(item?.subMenuItems?.some((submenu) => isRouteActive(location, submenu.slug)))
  }, [item, location])

  // También consideramos activo el padre si la ruta actual está bajo el slug del padre
  const isParentRouteActive = useMemo(() => {
    return item?.slug ? isRouteActive(location, item.slug) : false
  }, [item, location])

  const [dropdown, setDropdown] = useState(isChildActive || isParentRouteActive)

  // Mantener abierto automáticamente si estamos dentro (padre o hijo)
  useEffect(() => {
    if (isChildActive || isParentRouteActive) {
      setDropdown(true)
    }
  }, [isChildActive, isParentRouteActive])

  const isParentActive = isChildActive || isParentRouteActive

  // Item CON submenú
  if (item?.subMenuItems) {
    return (
      <>
        <li className="flex" title={item?.title} key={item?.title}>
          <button
            type="button"
            onClick={() => setDropdown((state) => !state)}
            className={`${baseClasses} ${nowrap} ${isParentActive ? '*:text-[#FCAE52] border-s-2 border-[#FCAE52]' : ''} w-full cursor-pointer`}
          >
            <div className={`${isSidebarOpen ? 'w-1/6' : 'flex flex-row items-center justify-between w-full'}`}>
              {item?.icon}
              {!isSidebarOpen && (dropdown ? <AiFillCaretUp /> : <AiFillCaretDown />)}
            </div>

            <div
              className={`w-5/6 ml-3 flex items-center justify-between uppercase origin-left duration-75 ${
                !isSidebarOpen ? 'scale-0' : ''
              }`}
            >
              <span>{item?.title}</span>
              {dropdown ? <AiFillCaretUp /> : <AiFillCaretDown />}
            </div>
          </button>
        </li>

        <ul className={`space-y-2 font-medium list-none ${!dropdown ? 'hidden' : ''}`}>
          {item?.subMenuItems.map((submenu) => (
            <SubMenuItems
              submenu={submenu}
              key={submenu.slug}
              location={location}
              isSidebarOpen={isSidebarOpen}
            />
          ))}
        </ul>
      </>
    )
  }

  // Item SIN submenú
  const isItemActive = isRouteActive(location, item?.slug)

  return (
    <li className="flex" title={item?.title} key={item?.title}>
      <Link
        id={item?.title}
        href={item?.slug}
        className={`${baseClasses} ${nowrap} ${isItemActive ? '*:text-[#FCAE52] border-s-2 border-[#FCAE52]' : ''}`}
      >
        <span className="w-1/6">{item?.icon}</span>

        <span className={`w-5/6 ml-3 origin-left duration-75 uppercase ${!isSidebarOpen ? 'scale-0' : ''}`}>
          {item?.title}
        </span>
      </Link>
    </li>
  )
}

MenuItems.propTypes = {
  item: PropTypes.object,
  user: PropTypes.object,
  location: PropTypes.string,
  isSidebarOpen: PropTypes.any
}